<div class="dialog-header">
  <h2 mat-dialog-title>
    <mat-icon>looks_one</mat-icon>
    Classificação da Fase 1
  </h2>
  <button mat-icon-button (click)="fechar()" class="btn-fechar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <table mat-table [dataSource]="classificacaoFase1" class="mat-elevation-z8">
    <ng-container matColumnDef="classificacao">
      <th mat-header-cell *matHeaderCellDef>Classificação</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon *ngIf="row.eliminado" class="eliminated-icon" matTooltip="Não Habilitado">close</mat-icon>
        <span *ngIf="!row.eliminado">{{ row.classificacao }}º</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="inscricaoId">
      <th mat-header-cell *matHeaderCellDef>Inscrição</th>
      <td mat-cell *matCellDef="let row">{{ row.inscricaoId }}</td>
    </ng-container>

    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef>Nome / Nome Social</th>
      <td mat-cell *matCellDef="let row">
        <strong>{{ row.nomeSocial || row.nome }}</strong>
        <img *ngIf="row.PCD" src="assets/icons/Accessibility_logo.png" class="accessibility-icon" matTooltip="Pessoa com Deficiência" alt="Pessoa com Deficiência">
        <br />
        <span *ngIf="row.nomeSocial" class="nome-social">/ {{ row.nomeSocial }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="nascimento">
      <th mat-header-cell *matHeaderCellDef>Nascimento</th>
      <td mat-cell *matCellDef="let row">{{ row.nascimento }}</td>
    </ng-container>

    <ng-container matColumnDef="mediaFinal">
      <th mat-header-cell *matHeaderCellDef>Média Final</th>
      <td mat-cell *matCellDef="let row">{{ row.mediaFinal | number:'1.2-2' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['classificacao', 'inscricaoId', 'nome', 'nascimento', 'mediaFinal']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['classificacao', 'inscricaoId', 'nome', 'nascimento', 'mediaFinal'];"></tr>
  </table>

  <div *ngIf="tiposProvaFase1.length > 0" class="scores-by-type">
    <div class="title">
      <mat-icon>assessment</mat-icon>
      <span>Resultados por prova</span>
    </div>
    
    <div class="exam-type-buttons">
      <button 
        *ngFor="let tipo of tiposProvaFase1" 
        mat-raised-button 
        [color]="tipoProvaSelecionadoFase1 === tipo ? 'primary' : ''"
        (click)="selecionarTipoProvaFase1(tipo)"
        class="mr-8 mb-8">
        {{ tipo }}
      </button>
    </div>

    <div *ngIf="tipoProvaSelecionadoFase1" class="scores-type-table">
      <table mat-table [dataSource]="notasPorTipoFase1[tipoProvaSelecionadoFase1]" class="mat-elevation-z8">

        <ng-container matColumnDef="inscricaoId">
          <th mat-header-cell *matHeaderCellDef>Inscrição</th>
          <td mat-cell *matCellDef="let row">{{ row.inscricaoId }}</td>
        </ng-container>

        <ng-container matColumnDef="nome">
          <th mat-header-cell *matHeaderCellDef>Nome / Nome Social</th>
          <td mat-cell *matCellDef="let row">
            <strong>{{ row.nomeSocial || row.nome }}</strong><br />
            <span *ngIf="row.nomeSocial" class="nome-social">/ {{ row.nomeSocial }}</span>
          </td>
        </ng-container>

        <ng-container *ngFor="let coluna of colunasPorTipoFase1[tipoProvaSelecionadoFase1]">
          <ng-container *ngIf="coluna !== 'nome' && coluna !== 'inscricaoId'" [matColumnDef]="coluna">
            <th mat-header-cell *matHeaderCellDef [matTooltip]="getComissaoMatriculaFase1(coluna) ? 'Matrícula: ' + getComissaoMatriculaFase1(coluna) : 'Externo Unicamp'">Prof.(a) Dr.(a) {{ getComissaoNomeFase1(coluna) }}</th>
            <td mat-cell *matCellDef="let row">{{ row[coluna] }}</td>
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunasPorTipoFase1[tipoProvaSelecionadoFase1]"></tr>
        <tr mat-row *matRowDef="let row; columns: colunasPorTipoFase1[tipoProvaSelecionadoFase1]"></tr>
      </table>
    </div>
  </div>
</mat-dialog-content>
